import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import { getCanonicalCoursesLessonPath } from '../utils/legacy-course-url'

/**
 * Courses Route Resolver Middleware
 *
 * Redirects the legacy courses lesson URL shape to the current one:
 *   .../categories/{moduleId}/posts/{lessonId}
 *     -> .../modules/{moduleId}/lessons/{lessonId}
 *
 * This is a legacy-URL canonicalization: the courses rename only swapped the
 * `categories` -> `modules` and `posts` -> `lessons` segment labels, so we rewrite
 * the path in place and preserve the surrounding context (standalone /courses,
 * communities /learning/courses, and the group-relative GoKollab shape). We use a
 * path-based `navigateTo` rather than a named-route `CPNavigateTo` because the
 * GoKollab lesson page has no named-route template (only a page alias), so name-based
 * resolution cannot reproduce that URL; a 1:1 path rewrite is correct for all shapes.
 *
 * Runs on both server and client, so direct loads, SPA navigations, and loads inside
 * the builder iframe are all redirected in place (query + hash preserved).
 */
export default defineNuxtRouteMiddleware(to => {
  const targetPath = getCanonicalCoursesLessonPath(to.path)
  if (!targetPath) {
    return
  }

  return navigateTo(
    // Preserve query (token, builder, location_id, template_id, is_preview, ...) and hash.
    { path: targetPath, query: to.query, hash: to.hash },
    { replace: true, redirectCode: 301 }
  )
})
